/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import moment from "moment";
import AlertStatusPopup from '../AlertStatusPopup/AlertStatusPopup.vue';
import viewAlertDetailsPopup from '../viewAlertDetailsPopup/viewAlertDetailsPopup.vue';
import viewAlertQueryPopup from '../ViewAlertQuery/viewAlertQueryPopup.vue';
import customModal from "../customModal/customModal.vue";

export default {
    name: "alerts",
    components: {
        AlertStatusPopup,
        viewAlertDetailsPopup,
        customModal,
        viewAlertQueryPopup,

    },
    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            showAlertpopup: false,
            showAlertMissing: false,
            showQueryAlertPopup: false,
            queryid: "",
            alertOutRange: [],
            querypopup: false,
            Querydetails: "",
            showloader: false,
            alerts: [],
            alertMissingList: [],
            activeAlerts: [],
            showAlertLoading: false,
            showActiveAlertLoading: false,
            showAlertStatusPopup: false,
            showAlertDetailsPopup: false,
            showAlertRecordModal: false,
            loadingActivity: false,
            alertId: "",
            showpop: false,
            showOutRange: false,
            selectedSubjectId: "",
            subjectCode: "",
            siteCode: "",
            subjectList: [],
            subjectActivityList:[],
            summary: {
                totalsubjects: "",
                activealerts: "",
                missingdata: "",
                outofrange: "",
            },
            newAlert: {
                id: "",
                studyId: "",
                alertFor: "",
                templateId: "",
                templateName: "",
                fieldName: "",
                fieldLabel: "",
                alertMessage: "",
                priority: "",
                alertType: "",
                notificationMethod: "",
                alertTotalCount: "",
                alertRule: "",
                alertsCount: [],
                rule: [
                    {
                        condition: "",
                        value: [
                            ""
                        ]
                    }
                ],
                dataSource: "",
                active: true,
                rolesToNotify: [
                    ""
                ],
                notificationEmail: [
                    ""
                ]

            },
            notification: {
                message: 'Urgent: Data not uploaded for patient',
                email: 'admin@hospital.org',
                phone: '',
                urgency: 'High'
            },
            stats: {
                activeAlerts: 2,
                resolvedToday: 5,
                avgResponseTime: 18,
                staffOnDuty: 3
            },
            currentPage: 1,
            itemsPerPage: 5,
            showContent: true,
        };
    },
    mounted() {
        this.defaultdate = localStorage.getItem("dateformat");
        this.getActiveAlertsCounts();
        this.getAllALerts();        
        this.getActiveAlerts();
        window.addEventListener("studyIdChanged", (event) => {
            this.getActiveAlertsCounts()
            this.getAllALerts();
            this.getActiveAlerts();
        });
    },
    computed: {
        totalPages() {
            return Math.ceil(this.alerts.length / this.itemsPerPage);
        },
        paginatedAlerts() {
            const start = (this.currentPage - 1) * this.itemsPerPage;
            return this.alerts.slice(start, start + this.itemsPerPage);
        }
    },
    methods: {
        Openquerypopup(id) {
            this.querypopup = true;
            this.AlertId = id;
            this.openqueryapi(id);
        },
        async openqueryapi(id) {
            this.Querydetails = [];
            this.showloader = true;
            try {
                const token = store.getters.getIdToken;
                const response = await axios.get(
                    `${this.baseurl}/forms/query/querylist?StudyId=${store.getters.getStudyIs}&QueryFor_Id=${id}&SortProperty=QueryOpenStatus&SortOrder=1`,
                    { headers: { Authorization: "Bearer " + token } }
                );
                this.Querydetails = Array.isArray(response.data.results) ? response.data.results : [];
                if (this.Querydetails.length === 0) {
                    this.showContent = false;
                }
                else if (this.Querydetails.length > 0) {
                    this.showContent = true;
                }
                this.showloader = false;
                console.log("Query details:", this.Querydetails);
            } catch (error) {
                this.Querydetails = [];
                this.showContent = false;
                this.showloader = false;
                console.error("Error fetching query details:", error);

            }
        },
        viewforms(id) {
            this.showQueryAlertPopup = true;
            this.queryid = id;
        },
        applychanges() {
             this.$refs.viewPopup?.querycount()
            this.openqueryapi(this.alertId);
        },

        Closequerypopup() {
            this.querypopup = false;
            this.querylistpopup = true;
            console.log("Closed query popup", this.alertId);
        },
        relativeTime(data) {
            if (data) {
                return moment(data).fromNow();
            }
        },
        async onTotalSubjects() {
            this.subjectList = [];
            this.showpop = true;
            const idtoken = store.getters.getIdToken;
            const stdid = store.getters.getStudyIs;
            try {
                const response = await axios.get(
                    `${this.baseurl}/forms/alert/subjectalertaudit?studyId=${stdid}`,
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                );

                this.subjectList = Array.isArray(response.data.entities)
                    ? response.data.entities
                    : [];
                console.log("subjectList data:", this.subjectList);
            } catch (error) {
                this.subjectList = [];
                console.error("Error fetching subjectList data:", error);
            }
        },
        CloseSubjectList() {
            this.showpop = false;
        },
        CloseActiveAlertList() {
            this.showAlertpopup = false;
        },
        closedoption() {
            this.showQueryAlertPopup = false;
        },

        async onActiveAlerts() {
            this.activealerts = [];
            const idtoken = store.getters.getIdToken;
            const stdid = store.getters.getStudyIs;
            axios.get(
                `${this.baseurl}/forms/alert/getaudits?StudyId=${stdid}`,
                {
                    headers: {
                        Authorization: "Bearer " + idtoken,
                        "Content-Type": "application/json",
                    },
                }
            )
                .then(response => {
                    const allAlerts = Array.isArray(response.data.entities) ? response.data.entities : [];

                    this.activealerts = allAlerts.filter(alert => alert.status === 'Not Resolved');
                    this.showAlertpopup = true;
                })
                .catch(error => {
                    this.activealerts = [];

                    console.error("Error fetching resolved alerts:", error);
                });
        },
        CloseAlertMissList() {
            this.showAlertMissing = false;
        },
        async onMissingData() {
            this.alertMissingList = [];
            this.showAlertMissing = true;
            const idtoken = store.getters.getIdToken;
            const stdid = store.getters.getStudyIs;
            try {
                const response = await axios.get(
                    `${this.baseurl}/forms/alert/getaudits?studyId=${stdid}&AlertRule=Missing`,
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                );
                if (response.data.entities && response.data.entities.length > 0) {
                    const alertsMissingData = response.data.entities;

                    this.alertMissingList = response.data.entities;

                    console.log("Missing data alerts:", alertMissingList);
                }
            } catch (error) {
                console.error("Error fetching missing data alerts:", error);
            }
        },
        CloseAlertRangeList() {
            this.showOutRange = false;
        },
        async onOutOfRange() {
            this.alertOutRange = [];
            this.showOutRange = true;
            const idtoken = store.getters.getIdToken;
            const stdid = store.getters.getStudyIs;
            try {
                const response = await axios.get(
                    `${this.baseurl}/forms/alert/getaudits?studyId=${stdid}&RuleCondition=GREATER%20THAN&RuleCondition=GREATER%20THAN%20OR%20EQUAL%20TO&RuleCondition=LESS%20THAN&RuleCondition=LESS%20THAN%20OR%20EQUAL%20TO`,
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                );
                if (response.data.entities && response.data.entities.length > 0) {
                    this.alertOutRange = response.data.entities;
                    console.log("Out of range alerts:", this.alertOutRange);
                }
            } catch (error) {
                console.error("Error fetching out of range alerts:", error);
            }
        },

        openAlertStatusPopup(id) {
            this.showAlertStatusPopup = true;
            this.alertId = id;
            console.log("Alert ID for status popup:", this.alertId);
        },
        closeAlertStatusPopup() {
            this.showAlertStatusPopup = false;
            if (this.showAlertDetailsPopup == true) {
                this.$refs.viewPopup?.getActiveAlerts()
            }
            this.getActiveAlertsCounts();
            this.getAllALerts();
            this.getActiveAlerts();
        },
        viewAlertDetails(id, type) {
            this.showAlertDetailsPopup = true;
            this.alertType = type;
            this.alertId = id;
        },
        viewAlertRecords(subjectId, subjectCode, siteCode) {
            this.subjectCode = subjectCode
            this.siteCode = siteCode
            this.selectedSubjectId = subjectId
             this.getSubjectRecords()
            this.showAlertRecordModal = true
            
           
        },
        async getSubjectRecords() {
            this.loadingActivity = true
            try {
                const token = store.getters.getIdToken;
                const response = await axios.get(
                    `${this.baseurl}/forms/alert/getaudits?StudyId=${store.getters.getStudyIs}&SubjectId=${this.selectedSubjectId}&SortProperty=createdAt&SortOrder=1`,
                    { headers: { Authorization: "Bearer " + token } }
                );
                this.loadingActivity = false
                this.subjectActivityList = response.data.entities;
            } catch (error) {
                this.loadingActivity = false
                console.error("Error fetching alerts:", error);
            }
        },
        closeSubjectActivityModal() {
            this.showAlertRecordModal = false
            this.subjectActivityList = []
        },
        filterDate(data) {
            if (data) {
                return moment(data).format(this.defaultdate)
            }
        },
        async closeAlertDetailsPopup() {
            this.showAlertDetailsPopup = false;
        },
        formatDateTime(inputDate) {

            const date = new Date(inputDate);
            if (isNaN(date)) {
                console.error("Invalid date");
                return "";
            }
            const hours = date.getHours().toString().padStart(2, "0");
            const minutes = date.getMinutes().toString().padStart(2, "0");
            const seconds = "00";

            const day = date.getDate().toString().padStart(2, "0");
            const month = (date.getMonth() + 1).toString().padStart(2, "0");
            const year = date.getFullYear().toString();
            return `${hours}:${minutes}:${seconds}_${day}-${month}-${year}`;
        },
        async getAllALerts() {
            this.alerts = []
            this.showAlertLoading = true
            try {
                const token = store.getters.getIdToken;
                const response = await axios.get(
                    `${this.baseurl}/forms/alert/getaudits?StudyId=${store.getters.getStudyIs}&SortOrder=1`,
                    { headers: { Authorization: "Bearer " + token } }
                );
                this.showAlertLoading = false
                this.alerts = response.data.entities;
                this.alertTotalCount = response.data.totalCount;
            } catch (error) {
                this.showAlertLoading = false
                console.error("Error fetching alerts:", error);
            }
        },
        async getActiveAlertsCounts() {
            this.alerts = []
            this.showAlertLoading = true
            try {
                const token = store.getters.getIdToken;
                const response = await axios.get(
                    `${this.baseurl}/forms/alert/getcounts?StudyId=${store.getters.getStudyIs}`,
                    { headers: { Authorization: "Bearer " + token } }
                );
                this.showAlertLoading = false
                this.alertsCount = response.data;
                console.log("alerts count is,", this.alertsCount);
                this.summary.totalsubjects = response.data.TotalSubjects;
                this.summary.activealerts = response.data.ActiveAlerts;
                this.summary.missingdata = response.data.MissingData;
                this.summary.outofrange = response.data.OutOfRange;
            } catch (error) {
                this.showAlertLoading = false
                console.error("Error fetching alerts:", error);
            }
        },
        async getActiveAlerts() {
            this.activeAlerts = []
            this.showActiveAlertLoading = true
            try {
                const token = store.getters.getIdToken;
                const response = await axios.get(
                    `${this.baseurl}/forms/alert/subjectalertaudit?StudyId=${store.getters.getStudyIs}&Active=true`,
                    { headers: { Authorization: "Bearer " + token } }
                );
                this.activeAlerts = response.data.entities;
                this.summary.activealerts = response.data.totalCount;
                this.showActiveAlertLoading = false
                console.log("active alert is,", this.activeAlerts)
            } catch (error) {
                this.showActiveAlertLoading = false
                console.error("Error fetching alerts:", error);
            }
        },
        async addAlertRule() {
            try {
                const token = store.getters.getIdToken;
                await axios.post(
                    `${this.baseurl}/alerts/insert`,
                    this.newAlertRule,
                    { headers: { Authorization: "Bearer " + token } }
                );
                alert(this.$t("navigations.alert added successfully"));
            } catch (error) {
                console.error("Error adding alert rule:", error);
                alert("Failed to add alert rule");
            }
        },
        async sendNotification() {
            try {
                const token = store.getters.getIdToken;
                await axios.post(
                    `${this.baseurl}/notifications/send`,
                    this.notification,
                    { headers: { Authorization: "Bearer " + token } }
                );
                alert("Notification sent successfully!");
                this.notification.message = '';
            } catch (error) {
                console.error("Error sending notification:", error);
                alert("Failed to send notification");
            }
        },
        async resolveAlert(alertId) {
            try {
                const token = store.getters.getIdToken;
                await axios.put(
                    `${this.baseurl}/alerts/${alertId}/resolve`,
                    {},
                    { headers: { Authorization: "Bearer " + token } }
                );

                // Update local state
                this.alerts = this.alerts.map(alert =>
                    alert.id === alertId ? { ...alert, status: 'Resolved' } : alert
                );

                this.stats.activeAlerts = this.alerts.filter(a => a.status === 'Pending').length;
                this.stats.resolvedToday++;

            } catch (error) {
                console.error("Error resolving alert:", error);
                alert("Failed to resolve alert");
            }
        },
        refreshAlerts() {
            this.fetchAlerts();
        },
        formatDateTime(dateString) {
            if (!dateString) return '';
            return moment(dateString).format('MMM D, YYYY h:mm A');
        },
        alertTypeClass(type) {
            switch (type) {
                case 'Safety Alert': return 'safety-badge';
                case 'Lab Results': return 'lab-badge';
                case 'Medication Records': return 'med-badge';
                default: return 'other-badge';
            }
        }
    },

};